module.exports = __webpack_public_path__ + "img/lwp.70d75d3c.png";